import React from "react";

const SearchBar = React.memo(({
  searchQuery,
  setSearchQuery,
  statusFilter,
  setStatusFilter,
  searchInputRef,
  filteredCount,
  totalCount
}) => {
  return (
    <div className="mb-6">
      <div className="relative w-full sm:max-w-lg">
        <input
          ref={searchInputRef}
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Tìm kiếm (Ctrl+K)"
          className="w-full pl-10 pr-10 py-3 bg-black/60 border border-cyan-400/50 rounded-xl text-cyan-100 placeholder-cyan-500/70 focus:border-cyan-400 focus:shadow-neon-cyan transition-all duration-300 font-mono backdrop-blur-sm"
        />
        {searchQuery && (
          <button
            onClick={() => setSearchQuery("")}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-cyan-400 hover:text-pink-400 transition-colors duration-300"
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
      {(searchQuery || statusFilter !== "all") && (
        <div className="mt-3 flex flex-wrap items-center gap-4 text-sm text-gray-300 font-mono">
          <div className="flex items-center gap-2">
            <svg className="w-4 h-4 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-cyan-300">
              [TÌM THẤY] {filteredCount} / {totalCount} TỪ VỰNG
            </span>
          </div>
          {(searchQuery || statusFilter !== "all") && (
            <button
              onClick={() => {
                setSearchQuery("");
                setStatusFilter("all");
              }}
              className="flex items-center gap-2 text-pink-400 hover:text-pink-300 font-medium transition-colors duration-300"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
              [XÓA BỘ LỌC]
            </button>
          )}
        </div>
      )}
    </div>
  );
});

export default SearchBar; 